/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'action/conversion_alt': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M10.696 21.303l-.707.707A8.446 8.446 0 017.5 16c0-4.006 2.79-7.365 6.526-8.26C14.154 6.76 14.984 6 16 6a2 2 0 010 4c-.842 0-1.56-.521-1.854-1.259C10.906 9.57 8.5 12.506 8.5 16c0 2.003.78 3.886 2.196 5.303zm7.279 2.957A1.995 1.995 0 0114 24a2 2 0 012-2c.842 0 1.561.521 1.854 1.259C21.094 22.43 23.5 19.494 23.5 16a7.454 7.454 0 00-2.193-5.301l.707-.707A8.447 8.447 0 0124.5 16c0 4.006-2.79 7.365-6.525 8.26z"/>'
  }
})
